import { defineMessages } from 'react-intl';

const messages = defineMessages({
  featureSectionTitle: {
    description: 'Title for the feature section',
    defaultMessage: 'Explore ShipStation Features',
    id: 'mUm9eW',
  },

  // Rate Shopping Card
  rateShoppingTitle: {
    description: 'Title for rate shopping feature card',
    defaultMessage: 'Automate rate shopping',
    id: 'BYyWPH',
  },
  rateShoppingDescription: {
    description: 'Description for rate shopping feature card',
    defaultMessage: 'Automatically apply the best rate to all your orders with Rate Shopper. Add custom rules to meet to your needs.',
    id: 'Luy+7a',
  },

  // Automation Rules Card
  automationRulesTitle: {
    description: 'Title for automation rules feature card',
    defaultMessage: 'Save time with automation rules',
    id: '5iwwtM',
  },
  automationRulesDescription: {
    description: 'Description for automation rules feature card',
    defaultMessage: 'Save hours of work each week by automating manual tasks like comparing rates, selecting services, and much more.',
    id: '3Reh/v',
  },

  // Business Insights Card
  insightsTitle: {
    description: 'Title for business insights feature card',
    defaultMessage: 'Report on your operations',
    id: 'tE45KB',
  },
  insightsDescription: {
    description: 'Description for business insights feature card',
    defaultMessage: 'Gain operational insights and find opportunities to improve across many facets of your fulfillment workflows.',
    id: 'pP7QSc',
  },

  // Warehouse Operations Card
  inventoryTitle: {
    description: 'Title for inventory operations feature card',
    defaultMessage: 'Manage your inventory',
    id: 'BuikXp',
  },
  inventoryDescription: {
    description: 'Description for inventory operations feature card',
    defaultMessage: 'Upload your product records and inventory counts. Ensure you always have the stock to fulfill your orders.',
    id: '+kGWR/',
  },

  // Customer Returns Card
  returnsTitle: {
    description: 'Title for customer returns feature card',
    defaultMessage: 'Create customer loyalty with returns',
    id: 'c1Dad8',
  },
  returnsDescription: {
    description: 'Description for customer returns feature card',
    defaultMessage: 'Offer easy returns and exchanges to your customers. Minimize the complexity with our automation options.',
    id: 'd/MdQU',
  },

  // Fulfilled by ShipStation Card
  fulfillmentTitle: {
    description: 'Title for ShipStation fulfillment feature card',
    defaultMessage: 'Scale your fulfillment process',
    id: 'J6ppzL',
  },
  fulfillmentDescription: {
    description: 'Description for Fulfilled by ShipStation feature card',
    defaultMessage: 'Partner with Fulfilled by ShipStation for optimal fulfillment, no matter where your customers are.',
    id: 'iM7BPO',
  },

  // Warehouse Operations Card
  warehouseTitle: {
    description: 'Title for warehouse operations feature card',
    defaultMessage: 'Customize your warehouse operations ',
    id: 'EDT/lS',
  },
  warehouseDescription: {
    description: 'Description for warehouse operations feature card',
    defaultMessage: 'Manage warehouse locations, customize your pick and pack process, and implement barcode scanning workflows.',
    id: 'ZPD871',
  },
  // Branding Card
  brandingTitle: {
    description: 'Title for branding feature card',
    defaultMessage: 'Brand your returns experience',
    id: 'DkrPZz',
  },
  brandingDescription: {
    description: 'Description for branding feature card',
    defaultMessage: 'Customize your return portal with your logo, colors, and messaging. Make it feel like your brand.',
    id: 'uUAWrO',
  },
});

export default messages;
